import React, { useCallback, useMemo, useState } from 'react';
import styles from './PlayerComment.module.scss';
import Icon from '../Icon/Icon';
import { useInPlayerCommentContext } from '../../context/InPlayerCommentContext';
import HoverPlayerContent from './HoverPlayerContent';
import { useVideoProgressContext } from '../../context/VideoProgressContext';

const MAX_AMOUNT_TO_DISPLAY = 9;
const MAX_WIDTH = 0.5; // 70 percents of player width
const MAX_HEIGHT = 0.6; // 50 percents of player height
const ICON_WIDTH = 18;

const PlayerComment = ({ id, secondsValue, comments, duration, disable = false }) => {
  const [isHover, setIsHover] = useState(false);

  const { width: playerWidth, height: playerHeight } = document.getElementById(id)?.getBoundingClientRect() || {};

  const { handleCommentClick, addNotesMode } = useInPlayerCommentContext();
  const { updateVideoSeekToValue } = useVideoProgressContext();

  const handleOnClick = () => useCallback(() => {
      updateVideoSeekToValue({ value: secondsValue, playing: false });
  }, [addNotesMode, secondsValue]);

  const commentStyles = useMemo(() => {
    const left = secondsValue / duration * 100;
    let transform = `translate(calc(-100% + ${ICON_WIDTH}px), -100%)`

    if (left < 50) {
      transform = 'translate(0%, -100%)';
    }

    return {
      transform,
      width: 'max-content',
      maxWidth: `${playerWidth * MAX_WIDTH}px`, // half of the player
    }
  }, [secondsValue, duration, playerWidth]);

  const commentIconStyles = useMemo(() => {
    let left = secondsValue / duration * 100;
    let transform = 'translate(-20%, -100%)';

    if (((ICON_WIDTH / playerWidth) * 100) + left > 100) {
      left = 100;
      transform = 'translate(-100%, -100%)';
    }

    return {
      left: `${left}%`,
      transform,
    }
  }, [secondsValue, duration, playerWidth]);

  return (
    <div
      key={secondsValue}
      className={styles.comment}
      style={commentIconStyles}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      onClick={handleOnClick(comments)}
    >
      {isHover && (
        <HoverPlayerContent comment={comments[0]} sameTimestampComments={comments?.length} showGoToComment={true} commentStyles={commentStyles} maxHeight={playerHeight * MAX_HEIGHT} onClick={() => handleCommentClick(comments)} />
      )}
      {comments?.length > 1 && comments?.length < MAX_AMOUNT_TO_DISPLAY && (
        <span className={styles.commentsAmount}>{comments?.length}</span>
      )}
      <Icon src="comment_dark" verticalAlign="middle" className={styles.commentIcon} />
    </div>
  )
};

export default PlayerComment;